<template>
  <vue-tel-input
    type="tel"
    :model-value="valueInput"
    :class="[
      tipo === TIPOS_TELEFONO.TIPO_A
        ? 'input-telefono-tipo-a text-primary text-start text-12'
        : 'input-telefono-tipo-b form-control bg-light border-0 py-3',
      { 'is-field-error': hasError },
    ]"
    :mode="showPrefijoCode ? MODOS_TELEFONO.NATIONAL : MODOS_TELEFONO.INTERNATIONAL"
    :input-options="{
      placeholder: placeholder,
    }"
    :dropdown-options="{
      showDialCodeInSelection: showPrefijoCode,
      showDialCodeInList: true,
      showFlags: true,
      showSearchBox: false,
      searchBoxPlaceholder: '',
      tabindex: 0,
    }"
    :required="required"
    :disabled="disable"
    @update:model-value="updateValue"
    @keypress.enter="keypressEnter">
  </vue-tel-input>
</template>

<script setup>
  import { ref, watch } from 'vue';
  import { VueTelInput } from 'vue-tel-input';
  import 'vue-tel-input/vue-tel-input.css';
  import { MODOS_TELEFONO, TIPOS_TELEFONO } from '@/constants/inputsConstants';

  const props = defineProps({
    modelValue: {
      required: true,
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    disable: {
      type: Boolean,
      default: false,
      required: false,
    },
    placeholder: {
      type: String,
      required: true,
    },
    tipo: {
      type: String,
      required: false,
      default: TIPOS_TELEFONO.TIPO_A,
    },
    hasError: {
      type: Boolean,
      default: false,
      required: false,
    },
    showPrefijoCode: {
      type: Boolean,
      default: false,
      required: false,
    },
  });

  const emits = defineEmits(['update:modelValue', 'enterUpdate']);

  const valueInput = ref(props.modelValue);

  function updateValue(value) {
    let processedValue = value;
    valueInput.value = processedValue;
    emits('update:modelValue', processedValue);
  }

  function keypressEnter(value) {
    emits('enterUpdate', value);
  }

  watch(
    () => props.modelValue,
    newValue => {
      valueInput.value = newValue;
    }
  );
</script>

<style lang="scss" scoped>
  .input-telefono-tipo-a {
    --bs-text-opacity: 1 !important;
    color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
    appearance: none !important;
    background-color: var(--bs-body-bg) !important;
    background-clip: padding-box !important;
    border: var(--bs-border-width) solid var(--bs-border-color) !important;
    border-radius: var(--bs-border-radius) !important;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
    width: 100% !important;
    padding: 0.2rem 0 !important;
    font-size: 1rem !important;
    font-weight: 400 !important;
    line-height: 1.5 !important;

    &.disabled {
      background-color: var(--bs-secondary-bg) !important;
      opacity: 1 !important;
    }

    :deep(.vti__input) {
      border-radius: var(--bs-border-radius-lg) !important;
      color: var(--bs-primary) !important;
      background: transparent none !important;
      text-align: left !important;
      padding-left: 0 !important;
    }
  }

  .input-telefono-tipo-b {
    display: flex !important;
    color: var(--landing-text-color, var(--bs-body-color)) !important;

    :deep(.vti__input) {
      border-radius: var(--bs-border-radius-lg) !important;
      color: var(--landing-text-color, var(--bs-body-color)) !important;
      background: transparent none !important;
      text-align: left !important;
      padding-left: 0 !important;
    }
  }
</style>
